import type { Observable } from 'rxjs';
import type { ActivateParticipantOutcome } from '../models/activate-participant.model';

export interface ActivateLeaderboardParticipantParams {
  commerceId: number;
  leaderboardId: string;
  uid: string;
  /** Required when the board has a terms URL configured. */
  termsAccepted?: boolean;
}

export abstract class LeaderboardParticipantPort {
  abstract activate(
    params: ActivateLeaderboardParticipantParams,
  ): Observable<ActivateParticipantOutcome>;
}
